"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utility class for retrieving document referrer.
 */
class EntryPoint {
    /**
     * Get document referrer.
     *
     * @returns The entry point as an object that contains host, pathname and search.
     */
    getEntryPoint() {
        const entryPoint = document.referrer;
        try {
            const url = new URL(entryPoint);
            return {
                host: url.host,
                pathname: url.pathname,
                search: url.search
            };
        }
        catch (e) {
            return undefined;
        }
    }
}
exports.default = EntryPoint;
//# sourceMappingURL=EntryPoint.js.map